import * as React from 'react';

const ListBullets = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
        >
            <path d="M8.25 3.748h15M8.25 12.748h15M8.25 21.748h15" />
            <rect width={4.5} height={4.5} x={0.75} y={0.748} rx={0.75} />
            <rect width={4.5} height={4.5} x={0.75} y={9.748} rx={0.75} />
            <rect width={4.5} height={4.5} x={0.75} y={18.748} rx={0.75} />
        </g>
    </svg>
);
export default ListBullets;
